import React, { useEffect,  useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { Loader } from "../../../../../components/Loader/Loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";
import {
  OpeningFan,
  TrialOpening,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Trial Balance/TrialBalanceSlice";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";

export default function OnlyOpening({ accountGroup, Fromdate, ToDate }) {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { TrialOpeningdata } = useSelector((state) => state.TrialBalanceSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(OpeningFan());
    dispatch(
      TrialOpening({
        Firm,
        Year: FinancialYear,
        selectedIds: accountGroup.join(","),
        Fromdate,
        ToDate,
      }),
    );
  }, [dispatch, Firm, FinancialYear, accountGroup, ToDate, Fromdate]);

  const formatAmount = (value) => {
    if (value === null || value === undefined || value === "") return "0.00";
    const num = Number(value);
    return isNaN(num) ? "0.00" : num.toFixed(2); // always 2 decimals
  };

  const getRows = TrialOpeningdata?.Detail?.map((item, index) => ({
    srNumber: index + 1,
    AcLaieName: item.AcLaieName,
    GroupMstName: item.GroupMstName,
    AcName: item.AcName,
    OpCrAmt: item.OpCrAmt,
    OpDrAmt: item.OpDrAmt,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Type",
      key: "AcLaieName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "AcGroup Name",
      key: "GroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Opening DrAmt", key: "OpDrAmt", align: "right", format: true },
    { label: "Opening CrAmt", key: "OpCrAmt", align: "right", format: true },
  ];

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });
    const formatIndianAmount = (value) => {
      const num = Number(value || 0);

      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    /* ================= TITLE ================= */
    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");

    const title = "Trial Balance Opening";

    doc.text(title, pageWidth / 2, 15, {
      align: "center",
    });

    doc.setLineWidth(0.5);
    doc.line(marginX, 18, pageWidth - marginX, 18);

    /* ================= FIRM NAME ================= */
    const firmName = DataMain?.Firm_List?.[0]?.GroupName || "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    doc.text(firmName, pageWidth / 2, 25, {
      align: "center",
    });

    /* ================= TABLE START ================= */
    let startY = 33;

    /* ================= DATA ================= */
    const allRows = TrialOpeningdata?.Detail || [];

    const liabilities = allRows.filter((r) =>
      (r.AcLaieName || "").toLowerCase().includes("liabil"),
    );

    const assets = allRows.filter((r) =>
      (r.AcLaieName || "").toLowerCase().includes("asset"),
    );

    const orderedRows = [...liabilities, ...assets];

    /* ================= TOTAL ================= */
    const totals = orderedRows.reduce(
      (acc, r) => {
        acc.OpDr += Number(r.OpDrAmt || 0);
        acc.OpCr += Number(r.OpCrAmt || 0);
        return acc;
      },
      { OpDr: 0, OpCr: 0 },
    );

    /* ================= FORMAT ================= */
    const formatAmount = (val) => {
      if (!val) return "0.00";
      return Number(val).toFixed(2);
    };

    /* ================= BODY ================= */
    let sr = 1;

    const bodyRows = orderedRows.map((row) => [
      sr++,
      row.AcLaieName || "",
      row.GroupMstName || "",
      row.AcName || "",
      formatIndianAmount(row.OpDrAmt || 0),
      formatIndianAmount(row.OpCrAmt || 0),
    ]);

    /* ================= TOTAL ROW ================= */
    bodyRows.push([
      "",
      "",
      "",
      "TOTAL",
      formatIndianAmount(totals.OpDr || 0),
      formatIndianAmount(totals.OpCr || 0),
    ]);

    /* ================= COLUMN WIDTH ================= */
    const colWidths = [10, 30, 40, 60, 30, 30];
    const tableWidth = colWidths.reduce((a, b) => a + b, 0);
    const leftMargin = (pageWidth - tableWidth) / 2;

    /* ================= TABLE ================= */
    autoTable(doc, {
      startY,

      margin: { left: leftMargin },

      head: [
        [
          "Sr",
          "Ac Type",
          "Ac Group",
          "Account Name",
          "Opening Dr",
          "Opening Cr",
        ],
      ],

      body: bodyRows,

      theme: "grid",
      showHead: "everyPage",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        valign: "middle",
        textColor: [0, 0, 0],
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        fontSize: 9,
      },

      bodyStyles: {
        fontStyle: "bold",
      },
      columnStyles: {
        0: { halign: "center", cellWidth: colWidths[0] },
        1: { halign: "left", cellWidth: colWidths[1] },
        2: { halign: "left", cellWidth: colWidths[2] },
        3: { halign: "left", cellWidth: colWidths[3] },
        4: { halign: "right", cellWidth: colWidths[4] },
        5: { halign: "right", cellWidth: colWidths[5] },
      },

      didParseCell: (data) => {
        if (data.row.raw?.[3] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [230, 230, 230];
        }
      },

      didDrawPage: () => {
        const pageNo = doc.internal.getCurrentPageInfo().pageNumber;

        doc.setFontSize(8);
        doc.text(`Page ${pageNo}`, marginX, pageHeight - 5);
      },
    });

    /* ================= SAVE ================= */
    doc.save("Trial_Balance_Opening.pdf");
  };

  if (TrialOpeningdata === "no" || TrialOpeningdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <button
          onClick={handleDownload}
          className="common-hover-btn"
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
            color:
              isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour12,
            border: "none",
            padding: "10px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "14px",
            height: "44px",
          }}
        >
          <Download size={16} />
          Download PDF
        </button>
      </div>
      <div style={{ marginTop: "20px" }}>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          {/* HEADER */}
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              padding: "14px",
              margin: 0,
              position: "relative",
              zIndex: 2,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              ONLY OPENING
            </h2>
          </div>

          {/* TABLE */}
          {/* <FASparentMultipalChild
            data={getRows}
            columns={getColumns}
            externalTotals={TrialOpeningdata?.Summary?.[0] || {}}
          /> */}
          <FASparentMultipalChild data={getRows} columns={getColumns} />
        </div>
      </div>
    </>
  );
}
